export default {"src":"/uk/_next/static/media/spot-transfer-money.f0294944.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};